import Cookies from "js-cookie";
import { getLpCheckoutParams, getUTMParams } from "../utils";

export function decorateUrlWithAttributionParams(url: URL): URL {
  const amplitudeId = Cookies.get("bws_amplitude_device_id");
  if (amplitudeId) {
    url.searchParams.set("amplitudeId", amplitudeId);
    url.searchParams.set("amplitude_device_id", amplitudeId);
  }

  // kelly_funnel (bws-lp landing experiment): kelly_funnel_cell + stable_id on
  // every checkout session, mapped by Core to Stripe metadata kellyFunnelCell /
  // stableId. Nothing for other visitors.
  Object.entries(getLpCheckoutParams()).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  const params = getUTMParams();
  if (!params) return url;

  const paramMap: Record<string, string | null> = {
    utm_source: params.utm_source,
    utm_medium: params.utm_medium,
    utm_campaign: params.utm_campaign,
    utm_content: params.utm_content,
    utm_term: params.utm_term,
    fbp: params.fbp,
    fbc: params.fbc,
    _fbp: params.fbp,
    _fbc: params.fbc,
    // Google click / campaign ids. These key names must match METADATA_MAPPING
    // in bws-internal's checkout controller, which copies them into Stripe
    // customer metadata; the marketing webhook then reads gclid/gbraid/wbraid
    // back out and sends them to the Data Manager API as adIdentifiers.
    gclid: params.gclid,
    gbraid: params.gbraid,
    wbraid: params.wbraid,
    gad_campaignid: params.gad_campaignid,
    gad_source: params.gad_source,
    // TikTok match keys, mapped to Stripe metadata by the same controller.
    // _ttp is read here, not at landing: the pixel loads async and sets it
    // after the first render.
    ttclid: params.ttclid,
    ttp: Cookies.get("_ttp") ?? null,
  };

  Object.entries(paramMap).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });

  return url;
}
